import "jquery";
import "jquery-ui";
import "bootstrap";
import "ulysses/core";
import "globalize";
import "knockout";
import "ulysses/preferences";
import "ulysses/login.html";
import "ulysses/api";
import "sha";
import "wysihtml5";
import "moment";
import "leaflet";
import "markercluster";
import "cilogi-marker";
import "URI/URITemplate";
import "URI/URI";
import "pubsub";
import "jquery-libs/jquery.mousewheel";
import "gritter";
import "jquery-libs/jquery.validate";
import "jquery-libs/jquery.validate.methods";
import "jquery-libs/icheck";
import "sticky-kit";
import "jquery-libs/jquery.trap";
import "datatables.net";

// "datatables-responsive",
// "datatables-scroller",
// "datatables-colreorder",
//datatables boostrap has to be the last one
// "datatables.net",
import "ko.mapping-latest";

import "ko.observableDictionary";
import "jqueryui/jquery.ui.touch-punch";
import "jqueryui/jquery-ui-timepicker-addon";
import "bootstrap/bootstrap3-wysihtml5";
import "bootstrap/bootstrap-select";
import "bootstrap/jquery.validate.bootstrap.popover";
import "fileupload/jquery.iframe-transport";
import "fileupload/jquery.fileupload-ui";

//"lucene_query_parser.js",
import "marked";

import "iscroll";

//uh? "/static/js/mylibs/md5-min.js",
import "socket.io-client";

// "adminlte/app",
import "ulysses/widgets";

import "ulysses/core_widgets";
import "ulysses/core_controls";
import "ulysses/components/menu";
import "ulysses/components/notificationlist";
import "e-query";
import "ulysses/app";
console.log("All loaded and ready to go!");
window.$ =  $;
window.jQuery = $;
